import { apiSlice } from 'store/api/apiSlice';

export const ordersAPISlice: any = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createNewCustomerOrder: builder.mutation({
      query: (createCustomerBody) => ({
        url: `/customer-app/public/new-customer-order`,
        method: 'POST',
        body: createCustomerBody,
      }),
    }),
    verifyTable: builder.mutation({
      query: ({ orderId, tableCode }) => ({
        url: `/customer-app/public/verify-table?orderId=${orderId}`,
        method: 'POST',
        body: tableCode,
      }),
    }),
    updateOrderItemQuantityByProductId: builder.mutation({
      query: ({ orderItemId, quantity }) => {
        const url = `/order-items/public/update-quantity?id=${orderItemId}&quantity=${quantity}`;
        return {
          url,
          method: 'PUT',
        };
      },
    }),
    getPreviousCustomizationsByProductMasterIdAndOrderId: builder.query({
      query: ({ orderId, productMasterId }) => ({
        url: `/order-items/public/productMaster-orderItems?orderId=${orderId}&productMasterId=${productMasterId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    addMenuItemToOrderByOrderId: builder.mutation({
      query: ({ orderId, menuItemsBody }) => ({
        url: `/order/public/addOrderItems?orderId=${orderId}`,
        method: 'POST',
        body: menuItemsBody,
      }),
    }),
    updateOrderItemInOrderByOrderItemId: builder.mutation({
      query: ({ orderItemId, orderItemBody }) => ({
        url: `/order/public/addOrderItems?orderItemId=${orderItemId}`,
        method: 'POST',
        body: orderItemBody,
      }),
    }),
    confirmOrderGroupByOrderGroupId: builder.mutation({
      query: (orderGroupId) => ({
        url: `/order/public/confirmation?orderGroupId=${orderGroupId}`,
        method: 'PUT',
      }),
    }),
    getOrderById: builder.query({
      query: ({ id }) => ({
        url: `/order/public?id=${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getMenuItemsForReorderByOrderId: builder.query({
      query: ({ orderId }) => ({
        url: `/order/public/reOrder?orderId=${orderId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateNewCustomerOrderMutation,
  useVerifyTableMutation,
  useUpdateOrderItemQuantityByProductIdMutation,
  useGetPreviousCustomizationsByProductMasterIdAndOrderIdQuery,
  useAddMenuItemToOrderByOrderIdMutation,
  useUpdateOrderItemInOrderByOrderItemIdMutation,
  useConfirmOrderGroupByOrderGroupIdMutation,
  useGetOrderByIdQuery,
  useGetMenuItemsForReorderByOrderIdQuery,
} = ordersAPISlice;
